<template>
  <v-row>
    <v-col cols="12" sm="6">
      <v-card v-if="!isMedicalQualifications" class="p-0" rounded="xl">
        <div style="padding: 20px 30px">
          <div class="d-flex justify-space-between align-center mb-2">
            <h6 class="text-subtitle-1 font-weight-bold">
              醫師資歷
            </h6>
            <v-btn
              color="teal lighten-2"
              class="text-subtitle-2 rounded-lg"
              dark
              style="width: 100px; height: 40px"
              @click="isMedicalQualifications = true"
            >
              <v-icon dark size="15" class="mr-2">
                mdi-pencil
              </v-icon>
              編輯
            </v-btn>
          </div>
          <v-list dense class="overflow-auto" style="height: 160px">
            <v-list-item
              v-for="(experience, index) in doctor.qualification?.split(',')"
              :key="index"
              class="pa-0"
            >
              <v-list-item-content>
                <v-list-item-title
                  class="text-body-1 grey--text text--darken-2 text-wrap"
                  style="line-height: 1.2rem;"
                >
                  {{ experience }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </div>
      </v-card>
      <medical-qualifications-form
        v-if="isMedicalQualifications"
        :show.sync="isMedicalQualifications"
        :doctor="doctor"
        @update="onUpdateQualifications"
      />
    </v-col>
    <v-col cols="12" sm="6">
      <v-card v-if="!isEducationalBackground" class="p-0" rounded="xl">
        <div style="padding: 20px 30px">
          <div class="d-flex justify-space-between align-center mb-2">
            <h6 class="text-subtitle-1 font-weight-bold align-center">
              教育背景
            </h6>
            <v-btn
              color="teal lighten-2"
              class="text-subtitle-2 rounded-lg"
              dark
              style="width: 100px; height: 40px"
              @click="isEducationalBackground = true"
            >
              <v-icon dark size="15" class="mr-2">
                mdi-pencil
              </v-icon>
              編輯
            </v-btn>
          </div>
          <v-list dense class="overflow-auto" style="height: 160px">
            <v-list-item
              v-for="(education, index) in doctor.education"
              :key="index"
              class="pa-0"
            >
              <v-list-item-avatar size="60">
                <v-img
                  :src="getEducationLogo(education.school)"
                  alt="education image"
                  class="rounded-full"
                  contain
                />
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title
                  class="text-body-1 grey--text text--darken-2"
                >
                  {{ education.name || education.school }} {{ education.partment }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </div>
      </v-card>
      <educational-background-form
        v-if="isEducationalBackground"
        :show.sync="isEducationalBackground"
        :doctor="doctor"
        @update="onUpdateEducation"
      />
    </v-col>
  </v-row>
</template>

<script>
import MedicalQualificationsForm from "@/components/settings/doctor/v2/MedicalQualificationsForm.vue";
import EducationalBackgroundForm from "@/components/settings/doctor/v2/EducationalBackgroundForm.vue";
import { educationItems } from "@/utils/sharedData";

export default {
  name: "DoctorEducationSection",

  components: { MedicalQualificationsForm, EducationalBackgroundForm },

  props: {
    doctor: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      isMedicalQualifications: false,
      isEducationalBackground: false,
    };
  },

  methods: {
    getEducationLogo(edu) {
      const education = educationItems.find(item => item.name === edu);
      return education?.logo || "https://dentco.tw/images/school/其他.png";
    },
    onUpdateQualifications(payload) {
      this.$emit("update-qualifications", payload);
    },
    onUpdateEducation(payload) {
      this.$emit("update-education", payload);
    },
  },
};
</script>
